var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOldNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5009 15.8334C12.5009 17.2142 11.3816 18.3334 10.0009 18.3334C8.62015 18.3334 7.50086 17.2142 7.50086 15.8334M11.4979 5.19891C11.8609 4.82398 12.0842 4.31313 12.0842 3.75011C12.0842 2.59952 11.1515 1.66678 10.0009 1.66678C8.85027 1.66678 7.91753 2.59952 7.91753 3.75011C7.91753 4.31313 8.14086 4.82398 8.50377 5.19891M2.12321 6.93591C2.11125 5.72646 2.76332 4.59704 3.81672 4.00267M17.8785 6.93591C17.8905 5.72645 17.2384 4.59704 16.185 4.00267M15.0009 9.33345C15.0009 8.18417 14.4741 7.08197 13.5364 6.26932C12.5987 5.45666 11.3269 5.00011 10.0009 5.00011C8.67478 5.00011 7.40301 5.45666 6.46532 6.26932C5.52764 7.08197 5.00086 8.18417 5.00086 9.33345C5.00086 11.2349 4.5293 12.6256 3.94091 13.6207C3.27031 14.7548 2.93501 15.3219 2.94825 15.4573C2.96339 15.6123 2.99129 15.6612 3.11698 15.7531C3.22683 15.8334 3.77878 15.8334 4.88268 15.8334H15.119C16.2229 15.8334 16.7749 15.8334 16.8847 15.7531C17.0104 15.6612 17.0383 15.6123 17.0535 15.4573C17.0667 15.3219 16.7314 14.7548 16.0608 13.6207C15.4724 12.6256 15.0009 11.2349 15.0009 9.33345Z",
    stroke: "#777777",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldNotification);
export default __webpack_public_path__ + "static/media/old-notification.5448d9e941d70e4c339dc2dcefbb9742.svg";
export { ForwardRef as ReactComponent };